/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["loading-indicator.overlay[_ngcontent-%COMP%]{background-color:transparent}"];
export { styles as styles };
